import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'search'
})
export class SearchPipe implements PipeTransform {

  transform<T>(value: T[], filterString: string, propNames: string[]): T[] {
    if (!value || value.length === 0 || !filterString) {
      return value;
    }

    const resultArray: Set<T> = new Set<T>();

    for (const item of value) {
      for (const propName of propNames) {
        let source = null;
        const parts = propName.split('.');

        do {
          const field = parts.shift();
          if (Array.isArray(item[field]) && item[field].length > 0 && parts.length > 0) {
            const found = this.transform(item[field], filterString, [parts.shift()]);
            if (found && found.length > 0) {
              resultArray.add(item);
            }
          } else {
            source = item[field];
          }
        } while (parts.length > 0);

        if (!source) {
          continue
        }

        if ((Array.isArray(source) && source.some(s => s.toString().toLowerCase().includes(filterString.toLowerCase()))) ||
          source.toString().toLowerCase().includes(filterString.toLowerCase())
        ) {
          resultArray.add(item);
        }
      }
    }
    return Array.from(resultArray);
  }

}
